import {Col, Row} from "react-bootstrap";
import {Block, Map} from "../components";
import React from "react";
import ShowItem from "../ShowItem";
import {useTranslation} from "react-i18next";
import JSONPretty from 'react-json-prettify';
import {github} from 'react-json-prettify/dist/themes';

function GeojsonFilter(props) {
  const { t } = useTranslation();

  const heightStyle = {
    height: '500px',
    marginBottom: '30px'
  }

  return (
    <Row>
      <Block as={Col} md={12} lg={6} fullHeight style={heightStyle}>
        <ShowItem label={t("zone.filterType")} value="Geojson" />
        <ShowItem label="Geojson" align={"start"} valueStyle={{paddingRight: 0}}>
          <JSONPretty json={props.geojson} theme={github} />
        </ShowItem>
      </Block>
      <Col md={12} lg={6} style={heightStyle}>
        <Map
          geojson={props.geojson}
          disabled={true}
        />
      </Col>
    </Row>
  )
}

export default GeojsonFilter
